import { getStoredConsent, type ConsentChoice } from './consent-storage';

/**
 * Sends Consent Mode v2 update to gtag (real library or pre-load stub).
 */
export function pushConsentToGtag(consent: ConsentChoice): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  const analytics = consent.analytics ? 'granted' : 'denied';
  const ads = consent.ads ? 'granted' : 'denied';
  window.gtag('consent', 'update', {
    analytics_storage: analytics,
    ad_storage: ads,
    ad_user_data: ads,
    ad_personalization: ads,
    personalization_storage: ads,
  });
}

/** Re-apply stored choice after navigation or for AdSense refresh signals */
export function syncStoredConsentToGtag(): void {
  const stored = getStoredConsent();
  if (stored) pushConsentToGtag(stored);
}
